import React, { useEffect } from "react";
import { useResetInputs } from "src/Contexts";
import { ModalCore } from "src/Pages/components";

import { FormOperadora } from "./FormularioOperadora";
import { UseFormOperadora } from "./Hook/UseFeaturesFormulario";

interface IModalOperadora {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalOperadora = ({
  openModal,
  setOpenModal,
}: IModalOperadora) => {
  const { resetInputs } = useResetInputs();

  const { handleSubmit, loading: loadingSubmit } = UseFormOperadora({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <ModalCore
      loadingSubmit={loadingSubmit}
      open={openModal}
      setOpen={setOpenModal}
      sxStyle={{ width: "500px" }}
      title="Operadora"
      titleSubmit="Salvar"
      onChange={handleSubmit}
    >
      <FormOperadora />
    </ModalCore>
  );
};
